import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressViAtlasServiceV2PlacesServiceV2Url(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/api/wix-atlas-service-web',
        destPath: '',
      },
      {
        srcPath: '/_api/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
      {
        srcPath: '/_api/wix-atlas-service-web',
        destPath: '',
      },
      {
        srcPath: '/api/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
      {
        srcPath: '/api/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
      {
        srcPath: '/api/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
      {
        srcPath: '/api/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/api/wix-atlas-service-web',
        destPath: '',
      },
    ],
    '*.wixforms.com': [
      {
        srcPath: '/_api/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'platform.rise.ai': [
      {
        srcPath: '/_api/wix-atlas-service-web',
        destPath: '',
      },
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/api/wix-atlas-service-web',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_atlas_places';

/** Once you have a search_id from a autocomplete Search, you can request more details about a particular establishment or point of interest by initiating a get place request. */
export function getPlace(payload: object): RequestOptionsFactory<any> {
  function __getPlace({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.atlas.v2.place',
      method: 'GET' as any,
      methodFqn: 'com.wixpress.vi.atlas.service.v2.PlacesServiceV2.GetPlace',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressViAtlasServiceV2PlacesServiceV2Url({
        protoPath: '/v2/place',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'place.address.geocode.latitude' },
              { path: 'place.address.geocode.longitude' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getPlace;
}
